<template>
  <ErrorBase
    error-code="500"
    :title="$t('sbErrorPages.title')"
    :sub-title="$t('sbErrorPages.sbFiveHundred.subTitle')"
  >
    <p class="help-text">
      <sb-text value="sbErrorPages.sbFiveHundred.helpText" />
      <a
        class="text-lowercase"
        href="https://support.shipbob.com/hc/en-us/requests/new"
      >
        <sb-text value="common.support" />
      </a>.
    </p>
  </ErrorBase>
</template>

<script>
import SbText from '@src/components/Text/SbText.vue';
import ErrorBase from '@src/pages/Error/components/ErrorBase.vue';

/**
 * Shows how to layout and structure a 500 page.
 */
export default {
  name: 'FiveHundred',
  components: {
    ErrorBase,
    SbText,
  },
};
</script>

<style scoped lang="scss">
@import '@src/pages/Error/style/five-hundred.scss';
</style>
